import React, {useEffect, useState} from 'react';
import Slider from "react-slick";
import Link from 'next/link';
import Image from 'next/image';
import ProductImage from './ProductImage';
import BuyButton from '../ProductsListing/BuyButton';

const slider_setting_cardContent = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
};
const CardWithPrice = ({cardContent, addProductsToCart,imgTag}) => {

    return(
      <>
      {cardContent.length > 7
        ?
        <div className="inner-wrap-prod">
          <Slider {...slider_setting_cardContent}>
                {cardContent.map((val, i) =>
                      <div className="card-wrapper" key={i}>
                          <div className="img-wrapper scale-in">
                            <ProductImage imgTag={imgTag} slug={`/producto/${val.slug}`} imageName={val.image}></ProductImage>
                          </div>
                          <Link passHref={true} href={`/productos/${val.slug}`}><a><p className="title">{val.title}</p></a></Link>
                          {val?.unitDiscountAmount !== null && val?.unitDiscountAmount !== "" ? <><p className="mb-0"><span>{val?.price}€</span> <label className="blue-text">{val?.unitDiscountAmount}€</label></p></>: <><p className="text-left">{val?.price}€</p></>}
                          <BuyButton available={val?.available} productId={val?.id}></BuyButton>

                      </div>
                  )
              }
              </Slider>
        </div>
        :
          <div className="inner-wrap-prod rowdata noslider">
            <div className="row">
              {cardContent.map((val, i) =>
                  <div className="col-2 card-wrapper" key={i}>
                      <div className="img-wrapper"> <ProductImage slug={`/productos/${val.slug}`} imageName={val.image}></ProductImage> </div>
                      <Link passHref={true} href={`/productos/${val.slug}`}><a><p className="title">{val.title}</p></a></Link>
                      {val?.unitDiscountAmount != 0 ? <><p className="mb-0"><span>{val?.price}€</span> <label className="blue-text">{val?.unitDiscountAmount}€</label></p></>: <><p className="text-left">{val?.price}€</p></>}
                      <BuyButton available={val?.available} productId={val?.id}></BuyButton>

                    </div>
                )
              }
            </div>
          </div>
      }

      </>
    )
}

export default CardWithPrice;
